import './App.css';
import React, { createContext, useState } from 'react';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import RoutesList from './Routes';
import NavBar from './Components/Nav/Nav';
import SectionBar from './Components/SectionBar/SectionBar';
import IllustrationBar from './Components/IllustrationBar/IllustrationBar';
import frFlag from '../src/Components/Nav/Assets/fr.png'

// Création et export du contexte pour partager la variable
export const SharedVariableContext = createContext();


function App() 
{
  const [typeDePage, MajTypeDePage] = useState('');
  const [illustration, MajIllustration] = useState('');
  const [selectedOption, setSelectedOption] = useState({
                                                        value: 'fr',
                                                        label: 'Français',
                                                        img: frFlag,
                                                      });

  return (
    <>
      <SharedVariableContext.Provider value={{ typeDePage, MajTypeDePage, illustration, MajIllustration, selectedOption, setSelectedOption }}>
        <Header/>
        <NavBar/>
        <main>
          <IllustrationBar/>
          <RoutesList/>
          <SectionBar/>
        </main>
        <Footer/>
      </SharedVariableContext.Provider>
    </>
  );
}

export default App;
